import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

export const FreeTrialEndModalReason = {
  UPGRADE: 'upgrade',
  CREDIT_END: 'credit_end',
};

export type FreeTrialEndModalReasonKeys =
  (typeof FreeTrialEndModalReason)[keyof typeof FreeTrialEndModalReason];

type FreeTrialEndModalState = {
  isFreeTrialEndModalOpen: boolean;
  freeTrialEndModalReason: FreeTrialEndModalReasonKeys | null;
  freeTrialEndModalSource: string;
  onTrialUpgradeSuccess: (() => void) | null;
};

const initialState: FreeTrialEndModalState = {
  isFreeTrialEndModalOpen: false,
  freeTrialEndModalReason: null,
  freeTrialEndModalSource: '',
  onTrialUpgradeSuccess: null,
};

const freeTrialEndModalStore = create<FreeTrialEndModalState>()(
  devtools(immer(() => initialState))
);

export const freeTrialEndModalActions = {
  openFreeTrialEndModal: () => {
    freeTrialEndModalStore.setState((state) => {
      state.isFreeTrialEndModalOpen = true;
    });
  },
  closeAndResetFreeTrialEndModal: () => {
    freeTrialEndModalStore.setState((state) => {
      state.isFreeTrialEndModalOpen = false;
      state.freeTrialEndModalReason = null;
      state.freeTrialEndModalSource = '';
      state.onTrialUpgradeSuccess = null;
    });
  },
  setFreeTrialEndModalReason: (reason: FreeTrialEndModalReasonKeys | null) =>
    freeTrialEndModalStore.setState((state) => {
      state.freeTrialEndModalReason = reason;
    }),
  setFreeTrialEndModalSource: (source: string) =>
    freeTrialEndModalStore.setState((state) => {
      state.freeTrialEndModalSource = source;
    }),
  setOnTrialUpgradeSuccess: (onSuccess: () => void) =>
    freeTrialEndModalStore.setState((state) => {
      state.onTrialUpgradeSuccess = onSuccess;
    }),
};

export default freeTrialEndModalStore;
